export default function Download() {
  return (
    <section id="download" className="px-6 md:px-10 py-20 md:py-28 bg-background-50">
      <div className="relative overflow-hidden rounded-3xl bg-primary-700">
        <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-primary-500/60 blur-3xl"></div>
        <div className="absolute -bottom-24 -left-12 w-72 h-72 rounded-full bg-accent-500/30 blur-3xl"></div>

        <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-10 items-center px-8 md:px-14 py-14 md:py-20">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 bg-background-50/15 border border-background-50/30 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full mb-5">
              <i className="ri-sparkling-2-line"></i>
              Ứng dụng VF Money
            </span>
            <h2 className="font-heading text-background-50 text-3xl md:text-5xl leading-tight mb-5">
              Tải app, vay nhanh ngay trên điện thoại của bạn
            </h2>
            <p className="text-background-100/85 text-base md:text-lg mb-8 max-w-xl">
              Trải nghiệm quy trình đăng ký, ký hợp đồng điện tử và nhận tiền hoàn
              toàn trong ứng dụng. Hỗ trợ cả iOS và Android.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#"
                className="inline-flex items-center gap-3 bg-foreground-950 hover:bg-foreground-900 text-background-50 px-6 py-3.5 rounded-2xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-apple-fill text-3xl"></i>
                <div className="text-left">
                  <p className="text-[10px] tracking-wider uppercase text-background-100/80">Tải về từ</p>
                  <p className="text-sm font-bold leading-tight">App Store</p>
                </div>
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-3 bg-foreground-950 hover:bg-foreground-900 text-background-50 px-6 py-3.5 rounded-2xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-google-play-fill text-3xl"></i>
                <div className="text-left">
                  <p className="text-[10px] tracking-wider uppercase text-background-100/80">Tải về trên</p>
                  <p className="text-sm font-bold leading-tight">Google Play</p>
                </div>
              </a>
            </div>

            <div className="mt-8 flex items-center gap-6">
              <div className="text-background-50">
                <p className="font-heading text-3xl">4.8</p>
                <div className="flex items-center gap-0.5 text-accent-400 text-sm mt-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill"></i>
                  ))}
                </div>
                <p className="text-background-100/80 text-xs mt-1">12.000+ đánh giá</p>
              </div>
              <div className="h-12 w-px bg-background-50/30"></div>
              <div className="text-background-50">
                <p className="font-heading text-3xl">100K+</p>
                <p className="text-background-100/80 text-xs mt-2">Lượt tải</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            {/* Outer phone frame with metallic bezel */}
            <div className="relative w-[280px] md:w-[320px] aspect-[280/580] bg-foreground-950 rounded-[48px] p-[14px] border-[1px] border-foreground-800 shadow-2xl">
              {/* Left side buttons */}
              <div className="absolute left-[-3px] top-[110px] w-[3px] h-[28px] bg-foreground-800 rounded-l-sm"></div>
              <div className="absolute left-[-3px] top-[146px] w-[3px] h-[56px] bg-foreground-800 rounded-l-sm"></div>
              <div className="absolute left-[-3px] top-[210px] w-[3px] h-[56px] bg-foreground-800 rounded-l-sm"></div>
              {/* Right side button */}
              <div className="absolute right-[-3px] top-[160px] w-[3px] h-[72px] bg-foreground-800 rounded-r-sm"></div>

              <div className="w-full h-full rounded-[38px] overflow-hidden relative bg-gradient-to-b from-primary-100 to-background-50">
                {/* Dynamic Island */}
                <div className="absolute top-3 left-1/2 -translate-x-1/2 z-20">
                  <div className="w-[110px] h-[32px] bg-foreground-950 rounded-full flex items-center px-3 gap-2">
                    <div className="w-3 h-3 rounded-full bg-foreground-800"></div>
                    <div className="w-3 h-3 rounded-full bg-foreground-800"></div>
                  </div>
                </div>

                <div className="absolute inset-0 flex flex-col items-center justify-center px-6 pt-[36px]">
                  <div className="w-16 h-16 rounded-2xl bg-background-50 flex items-center justify-center mb-5">
                    <i className="ri-bank-fill text-primary-600 text-3xl"></i>
                  </div>
                  <h3 className="font-heading text-foreground-950 text-2xl text-center leading-tight">
                    Chào mừng trở lại!
                  </h3>
                  <p className="text-foreground-600 text-xs text-center mt-2 leading-relaxed">
                    Đăng nhập để quản lý khoản vay và nhận ưu đãi mới nhất.
                  </p>

                  <div className="grid grid-cols-3 gap-2 w-full mt-6">
                    {[
                      { icon: "ri-flashlight-line", label: "Giải ngân siêu tốc", tone: "primary" },
                      { icon: "ri-shield-line", label: "Bảo mật tuyệt đối", tone: "accent" },
                      { icon: "ri-smartphone-line", label: "100% Online", tone: "secondary" },
                    ].map((b) => (
                      <div
                        key={b.label}
                        className="bg-background-50 border border-background-200 rounded-xl p-2 text-center"
                      >
                        <div
                          className={`w-7 h-7 rounded-full flex items-center justify-center mx-auto ${
                            b.tone === "primary"
                              ? "bg-primary-100 text-primary-700"
                              : b.tone === "accent"
                              ? "bg-accent-100 text-accent-700"
                              : "bg-secondary-100 text-secondary-800"
                          }`}
                        >
                          <i className={`${b.icon} text-sm`}></i>
                        </div>
                        <p className="text-[9px] text-foreground-700 font-medium mt-1.5 leading-tight">
                          {b.label}
                        </p>
                      </div>
                    ))}
                  </div>

                  <div className="w-full bg-background-50 border border-background-200 rounded-2xl p-3 mt-4">
                    <p className="text-[10px] text-foreground-500">Số điện thoại đăng nhập</p>
                    <div className="flex items-center gap-2 mt-2">
                      <span className="bg-background-100 rounded-lg px-2 py-1 text-xs font-bold text-foreground-900">
                        +84
                      </span>
                      <span className="text-foreground-400 text-xs">Nhập số điện thoại</span>
                    </div>
                  </div>

                  <button className="mt-4 w-full bg-primary-600 text-background-50 text-sm font-semibold py-3 rounded-full cursor-pointer whitespace-nowrap">
                    Tiếp tục →
                  </button>
                </div>

                {/* Home indicator */}
                <div className="absolute bottom-[3px] left-1/2 -translate-x-1/2 z-20">
                  <div className="w-[120px] h-[5px] bg-foreground-950 rounded-full opacity-60"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}